import { isMaieShell } from './maieShell';
import { DESIGN_ROLES } from './designRoles';
import type { DesignRoleId } from './designRoles';
import { doorRouteFor } from '@/pages/roles/registry';

/**
 * WHERE "HOME" IS.
 *
 * Seven call sites hardcoded `/dashboard` — FeatureGuard's two "back" links,
 * DependencyGuard, the command palette, the recorder's offline fallback,
 * useAppNavigation. So however carefully the rail was rebuilt, a doctor who
 * hit a feature gate or finished a consult offline was still posted to a
 * legacy page the design replaced: a second "Dashboard" heading inside the new
 * chrome, on a screen with no door leading to it.
 *
 * `/dashboard` is not even the product's own answer any more — the nav diet
 * already forwards it to `/home?scope=clinic`. It was simply never told about
 * the design shell, which is a different flag.
 *
 * Under the design, home is the role's FIRST DOOR: the doctor's Today, the
 * receptionist's desk. That is the definition the rail already uses, so the two
 * cannot drift.
 */
export function homeRoute(surface?: DesignRoleId | null): string {
  if (!isMaieShell()) return '/dashboard';
  const door = surface ? DESIGN_ROLES[surface]?.doors?.[0] : undefined;
  const first = surface && door ? (doorRouteFor(surface, door.key) ?? door.route) : undefined;
  // `/home` resolves by role on its own, which is the right fallback for a
  // role the design has no surface for.
  return first ?? '/home';
}
